import './style.css';

import {
  GatsbyImage,
  GatsbyImageProps,
  IGatsbyImageData,
} from 'gatsby-plugin-image';
import React, { CSSProperties } from 'react';

import { tw } from '../../utils/tailwind';
import { Box } from '../Core';

export interface IImage {
  alt: string | undefined;
  childImageSharp?:
    | {
        gatsbyImageData: IGatsbyImageData;
      }
    | undefined;
  extension?: string | undefined;
  url: string | undefined;
}
interface IImageProps extends Omit<GatsbyImageProps, 'alt' | 'image'> {
  alt?: string;
  disableDrag?: boolean;
  image: IImage | null;
  overlayOpacity?: number;
  style?: CSSProperties;
  withOverlay?: boolean;
  imageClassName?: string;
}

const Image: FCWithClassName<IImageProps> = (props) => {
  const {
    className,
    disableDrag = false,
    image,
    imageClassName,
    loading = 'lazy',
    objectFit,
    overlayOpacity,
    withOverlay = false,
    ...rest
  } = props;
  if (!image) return null;

  if (image?.childImageSharp?.gatsbyImageData) {
    return (
      // we wrap GatsbyImage because its CSS takes precedence over the one we pass in build but not in dev
      <Box
        className={tw(
          'overflow-hidden', // to make sure border radius for instance is working properly
          props.className,
          withOverlay ? 'image-with-overlay' : ''
        )}
      >
        <GatsbyImage
          image={image?.childImageSharp?.gatsbyImageData}
          alt={image.alt}
          loading={loading}
          imgStyle={{
            objectFit: objectFit ?? 'cover',
            ...(disableDrag ? { WebkitUserDrag: 'none' } : {}),
          }}
          className={tw(
            imageClassName,
            image?.childImageSharp?.gatsbyImageData.layout === 'fullWidth'
              ? 'h-full'
              : '', // if the image is fixed or constrained, we don't want to impact its height
            'max-h-full' // image might be larger than the container otherwise
          )}
          style={
            {
              '--overlay-opacity': overlayOpacity ?? '0.2',
            } as React.CSSProperties
          }
          {...rest}
        />
      </Box>
    );
  }
  return <img src={image.url} alt={image.alt} className={className} />;
};

export default Image;
